import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { StepperModule } from 'primeng/stepper';

import { type IStep } from '../../interfaces/step.interface';
import { TooltipModule } from 'primeng/tooltip';
import { RideTimelineTooltipComponent } from '../../../features/monitoring-center/components/ride-timeline-tooltip/ride-timeline-tooltip.component';
import { StepClassesPipe } from './pipes/step-classes.pipe';
import { UserRole } from '../../../core/auth/enums/userRoles';
import { BadgeComponent } from '../badge/badge.component';

@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [CommonModule, StepperModule, StepClassesPipe, TooltipModule, RideTimelineTooltipComponent, BadgeComponent],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepperComponent {
  /**
   * Steps to be displayed in the stepper component.
   * Each step should have a time, statusDescription, and statusType.
   */
  steps = input<IStep[]>([]);
  /**
   * Index of the currently active step in the stepper component.
   * This input determines which step is visually highlighted as active.
   */
  public readonly activeStep = input<number>(0);

  isClient = localStorage.getItem('role')?.toLowerCase() == UserRole.Client;
}
